import React from "react";
import TitlePage from "../../../components/section/TitlePage/Titlepage";
import { ChevronRightIcon } from "@heroicons/react/24/outline";

const AnotherOrder = ({
  totalQtyCancelation,
  totalPriceCancelation,
  totalQtyReturned,
  totalPriceReturned,
  exchangeQtyRequest,
  defectAcceptance,
}) => {
  return (
    <div className="w-[28%]">
      <div className="flex justify-between">
        <TitlePage size="text-[14px]" title="주문 취소/반품/교환/불량접수" />
        <p className=" cursor-pointer text-title-grey flex ml-2">
          주문내역 관리
          <ChevronRightIcon className="-mt-[18px]" width={15} />
        </p>
      </div>
      <div className="w-full h-[9.5rem] space-y-4 p-4 shadow-dashboard">
        <div className="flex justify-between">
          <p>주문 취소 요청</p>
          <p>
            {totalQtyCancelation}건 · {totalPriceCancelation}원
          </p>
        </div>
        <div className="flex justify-between">
          <p>반품 요청</p>
          <p>
            {totalQtyReturned}건 · {totalPriceReturned}원
          </p>
        </div>
        <div className="flex justify-between">
          <p>교환 요청</p>
          <p>{exchangeQtyRequest}건</p>
        </div>
        <div className="flex justify-between">
          <p>불량접수</p>
          <p>{defectAcceptance}건</p>
        </div>
      </div>
    </div>
  );
};

export default AnotherOrder;
